import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Valida formato archivo antes de subir
//ElementId: id elemento padre
//MimeType: formato del archivo
//ValidateCode: código referencia para elemento padre
export const ValidarFormatoArchivo = (validar) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/ValidaFormatoArchivos/ValidarFormato/', validar).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};